import ApiService from "@/core/services/api.service";

export const antMenuApi = {
    getListNameAnts: () => {
        return ApiService.get("/hierarchy/tree");
    },
    updateMenuState: (data) => {
        return ApiService.patch("/hierarchy/menu-state", data);
    },
    renameTenant: (tenantCode, data) => {
        return ApiService.patch(`/tenant/${tenantCode}/rename`, data);
    },
    exportHierarchyCsv: () => {
        return ApiService.get("/hierarchy/csv");
    },
};
